// extracted by mini-css-extract-plugin
export var textInput = "_cn-0";